import { RouterModule, Routes } from '@angular/router';
import { PasarelaPagoComponent } from './component/pasarela-pago/pasarela-pago.component';
import { TerminoWebpayComponent } from './component/termino-webpay/termino-webpay.component';
import { TerminoKhipuComponent } from './component/termino-khipu/termino-khipu.component';
import { ExitomComponent } from './component/exitom/exitom.component';
import { UrlIncorrectaComponent } from './component/url-incorrecta/url-incorrecta.component';

const routes: Routes = [
  {path:'',component:UrlIncorrectaComponent},
  {path:'pasarelapago/:token',component:PasarelaPagoComponent},
  {path:'terminowebpay',component:TerminoWebpayComponent},
  {path:'terminokhipu/:token',component:TerminoKhipuComponent},
  {path:'exitom/:token',component:ExitomComponent},
  {path:'**',component:UrlIncorrectaComponent}
];
export const appRoutingModule = RouterModule.forRoot(routes);
